export default function FooterCheckout() {
  return (
    <footer className="mt-auto mx-auto max-w-7xl mb-0 w-screen">
      <section className="px-2 lg:px-12 py-4 border-t">
        <div className="grid grid-cols-1 lg:grid-cols-3 items-center justify-between">
          <div className="grid col-span-full items-center">
            <div className="flex flex-wrap gap-2 items-center justify-center lg:justify-start">
              <p className="text-xs my-2 text-zinc-600 basis-full text-center lg:basis-auto">
                Formas de pagamento
              </p>
              <div className="px-3 py-2 border rounded-sm">
                <img
                  loading="lazy"
                  src="/images/visa-logo.webp"
                  height={26}
                  width={38}
                  alt="Logo do Direção Concursos"
                />
              </div>
              <div className="px-3 py-2 bg-[#1f72cd] border rounded-sm">
                <img
                  loading="lazy"
                  src="/images/american-express-logo.webp"
                  height={26}
                  width={38}
                  alt="Logo do Direção Concursos"
                />
              </div>
              <div className="px-3 py-2 border rounded-sm">
                <img
                  loading="lazy"
                  src="/images/mastercard-logo.webp"
                  height={26}
                  width={38}
                  alt="Logo do Direção Concursos"
                />
              </div>
              <div className="px-3 py-2 border rounded-sm">
                <img
                  loading="lazy"
                  src="/images/hipercard-logo.webp"
                  height={26}
                  width={38}
                  alt="Logo do Direção Concursos"
                />
              </div>
              <div className="px-3 py-2 border rounded-sm">
                <img
                  loading="lazy"
                  src="/images/elo-logo.webp"
                  height={26}
                  width={38}
                  alt="Logo do Direção Concursos"
                />
              </div>
              <div className="px-3 py-2 border rounded-sm">
                <img
                  loading="lazy"
                  src="/images/boleto-logo.webp"
                  height={26}
                  width={38}
                  alt="Logo do Direção Concursos"
                />
              </div>
              <div className="px-3 py-2 border rounded-sm">
                <img
                  loading="lazy"
                  src="/images/pix-logo.webp"
                  height={26}
                  width={38}
                  alt="Logo do Direção Concursos"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </footer>
  )
}
